import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Spinner } from "@/components/common";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ScanQueue from "@/pages/ScanQueue";
import ScanVerify from "@/pages/ScanVerify";
import MobileCapture from "@/pages/MobileCapture";
import Suppliers from "@/pages/Suppliers";
import Companies from "@/pages/Companies";
import SupplierDetail from "@/pages/SupplierDetail";
import Contracts from "@/pages/Contracts";
import Orders from "@/pages/Orders";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Assets from "@/pages/Assets";
import Budgets from "@/pages/Budgets";
import Accounting from "@/pages/Accounting";
import Kpi from "@/pages/Kpi";
import FixedAssets from "@/pages/FixedAssets";
import FixedAssetDetail from "@/pages/FixedAssetDetail";
import Extractions from "@/pages/Extractions";
import SettingsPage from "@/pages/Settings";
import AdminPage from "@/pages/Admin";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/capture" element={<Protected><MobileCapture /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/factures-a-traiter" element={<ScanQueue />} />
            <Route path="/factures-a-traiter/:id" element={<ScanVerify />} />
            <Route path="/fournisseurs" element={<Suppliers />} />
            <Route path="/societes" element={<Companies />} />
            <Route path="/fournisseurs/:id" element={<SupplierDetail />} />
            <Route path="/contrats" element={<Contracts />} />
            <Route path="/commandes" element={<Orders />} />
            <Route path="/factures" element={<Invoices />} />
            <Route path="/factures/:id" element={<InvoiceDetail />} />
            <Route path="/materiel" element={<Assets />} />
            <Route path="/budgets" element={<Budgets />} />
            <Route path="/comptabilite" element={<Accounting />} />
            <Route path="/immobilisations" element={<FixedAssets />} />
            <Route path="/immobilisations/:id" element={<FixedAssetDetail />} />
            <Route path="/kpi" element={<Kpi />} />
            <Route path="/extractions" element={<Extractions />} />
            <Route path="/parametres" element={<SettingsPage />} />
            <Route path="/administration" element={<AdminPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
